















import Years from './parts/years.vue'
import Year from './parts/year.vue'
import Month from './parts/month.vue'
import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"

@Component({
	components: {Years, Year, Month}
})
export default class PatientStatistics extends AbpBase {
	position = 0
	buttons = ['数据统计']

	tabRemove() {

	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/dialysisStatistics/index.vue